import Entity from '../../../core/domain/entity';
import UniqueEntityID from '../../../core/domain/unique_entity_id';
import { DietitianProps } from '../../dietitian/domain/dietitian';

export interface NewsProps {
  title: string;
  subtitle: string;
  content: string;
  date: Date;
  action?: string | undefined;
}

export class NewsId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): NewsId {
    return new NewsId(id);
  }
}

export class News extends Entity<NewsProps> {
  get newsId(): NewsId {
    return NewsId.create(this.id);
  }

  get title(): string {
    return this.props.title;
  }

  set title(value: string) {
    this.props.title = value;
  }

  get subtitle(): string {
    return this.props.subtitle;
  }

  set subtitle(value: string) {
    this.props.subtitle = value;
  }

  get content(): string {
    return this.props.content;
  }

  set content(value: string) {
    this.props.content = value;
  }

  get action(): string | undefined {
    return this.props.action;
  }

  set action(value: string | undefined) {
    this.props.action = value;
  }

  get date(): Date {
    return this.props.date;
  }

  set date(value: Date) {
    this.props.date = value;
  }

  private constructor(props: NewsProps, id?: UniqueEntityID) {
    super(props, id);
  }

  copyWith(props: DietitianProps): News {
    return News.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  public static create(props: NewsProps, id?: UniqueEntityID): News {
    return new News(props, id);
  }
}
